import { Routing } from '../Routes';
import { useApi, Res, fetchResourceMap } from '../../state/api';
import { Main } from '../Main/Main';
import { LoaderPage } from './LoaderPage';
import { ErrorPage } from './ErrorPage';
import { useTranslation } from '../../i18n/i18n';
import { Helmet } from 'react-helmet-async';
import { useConfig } from '../../config';
import './PrinterPage.css';
import { Link } from 'react-router-dom';

export const PrinterPage = (): JSX.Element => {
	const { data: printerBrands, error } = useApi(Res.printerBrands, {});
	const t = useTranslation().tonerGuide;
	const urls = useTranslation().routes;

	if (error) return <ErrorPage />;
	if (!printerBrands) return <LoaderPage />;

	const links = Object.entries(printerBrands).map((brand) => ({
		url: `${urls.printer}/${brand[0]}`,
		name: brand[1],
	}));

	return (
		<Main>
			<Helmet>
				<title>{t.title}</title>
				<meta name="description" content={t.meta} />
			</Helmet>
			<h1>{t.inkAndToner}</h1>
			<p>{t.widesRangeOfInk}</p>
			<hr />
			<PrinterListing links={links} />
		</Main>
	);
};

const PrinterListing = ({ links }: { links: { url: string; name: string }[] }): JSX.Element => {
	const { locale } = useConfig();
	const sortedLinks = links.sort((a, b) => a.name.localeCompare(b.name, locale, { sensitivity: 'base' }));
	return (
		<>
			<ul className="printer-listing link-listing link-listing--is-small" style={{ width: '90%' }}>
				{sortedLinks.map((l) => (
					<li key={l.name}>
						<Link to={l.url}>{l.name}</Link>
					</li>
				))}
			</ul>
		</>
	);
};

export const printerRouting: Routing = {
	path(urls) {
		return urls.printer;
	},
	component: PrinterPage,
	requiresAuth: false,
	preload: async (config) => {
		return fetchResourceMap(config, Res.printerBrands, {});
	},
};
